import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  DOCUMENT_DETAIL_CREATED_BY: {
    en: 'Created by',
    de: 'Erstellt von',
  },
  DOCUMENT_DETAIL_CREATED_AT: {
    en: 'Created at',
    de: 'Erstellt am',
  },
  DOCUMENT_DETAIL_EDIT: {
    en: 'Edit',
    de: 'Bearbeiten',
  },
  DOCUMENT_DETAIL_INVOICE: {
    en: 'Invoice',
    de: 'Rechnung',
  },
  DOCUMENT_DETAIL_PAGES: {
    en: 'Pages',
    de: 'Seiten',
  },
  DOCUMENT_DETAIL_DELETE_DIALOG_TITLE: {
    en: 'Are you sure that you want to delete this invoice container?',
    de: 'Sind sie sicher, dass sie diese Rechnung(en) löschen wollen?',
  },
  DOCUMENT_DASHBOARD_TITLE: {
    en: 'Processed Documents',
    de: 'Verarbeitete Dokumente',
  },
  DOCUMENT_DASHBOARD_MEASURED_VALUES: {
    en: 'Measured Values',
    de: 'Messwerte',
  },
  DOCUMENT_DASHBOARD_UNIT: {
    en: 'Unit',
    de: 'Einheit',
  },
  DOCUMENT_DASHBOARD_UNIT_ABSOLUTE: {
    en: 'Absolute',
    de: 'Absolut',
  },
  DOCUMENT_DASHBOARD_UNIT_PERCENT: {
    en: 'Percent',
    de: 'Prozent',
  },
  DOCUMENT_DASHBOARD_ACCEPTED_VALUES: {
    en: 'Accepted Val...',
    de: 'Angenommen Val...',
  },
  DOCUMENT_DASHBOARD_AUTOPROCESSED: {
    en: 'Autoprocessed',
    de: 'Automatisch verarbeitet',
  },
  DOCUMENT_DASHBOARD_VALIDATED: {
    en: 'Validated',
    de: 'Validiert',
  },
  DOCUMENT_DASHBOARD_CORRECTED: {
    en: 'Corrected',
    de: 'Korrigiert',
  },
  DOCUMENT_DASHBOARD_ACCEPTED: {
    en: 'Accepted',
    de: 'Angenommen',
  },
};
